module.exports = __webpack_public_path__ + "img/right_arrow.42b1009a.svg";